<template>
  <div>
    <div class="wrapper">
      <comheader :index="3"></comheader>
      <main id="content" role="main">
        <input type="hidden" name="hdnAgeText" id="hdnAgeText" value="Age" />
        <input
          type="hidden"
          name="hdnDateTimeText"
          id="hdnDateTimeText"
          value="Date Time (UTC)"
        />
        <input
          type="hidden"
          name="hdnAgeTitle"
          id="hdnAgeTitle"
          value="Click to show Age Format"
        />
        <input
          type="hidden"
          name="hdnDateTimeTitle"
          id="hdnDateTimeTitle"
          value="Click to show Datetime Format"
        />
        <input
          type="hidden"
          name="hdnTxnText"
          id="hdnTxnText"
          value="Txn Fee"
        />
        <input
          type="hidden"
          name="hdnGasPriceText"
          id="hdnGasPriceText"
          value="Gas Price"
        />
        <input
          type="hidden"
          name="hdnTxnFeeTitle"
          id="hdnTxnFeeTitle"
          value="(Gas Price * Gas Used by Txns) in Ether"
        />
        <input
          type="hidden"
          name="hdnGasPriceTitle"
          id="hdnGasPriceTitle"
          value="Gas Price in Gwei"
        />
        <div class="container space-top-1 space-bottom-2">
          <form
            method=""
            action=""
            id="ctl00"
            class="js-validate mt-2"
            novalidate="novalidate"
          >
            <div class="aspNetHidden">
              <input
                type="hidden"
                name="__EVENTTARGET"
                id="__EVENTTARGET"
                value=""
              />
              <input
                type="hidden"
                name="__EVENTARGUMENT"
                id="__EVENTARGUMENT"
                value=""
              />
              <input
                type="hidden"
                name="__LASTFOCUS"
                id="__LASTFOCUS"
                value=""
              />
              <input
                type="hidden"
                name="__VIEWSTATE"
                id="__VIEWSTATE"
                value="sZEg5YL9gGWJzc+kvT2518JMHvxzVJ0LIUVbS3RZnp/JMPjkswl7jk1sFtG6bTCcFUZsOzBiZnublAbTLE8Bx2wBMwSOjIBLRheo5j71dRGkCEAbk2zkd4PBb1v8XmkTI/kJ3nr5jJsiAOFy6IKn+6k86eJcqNDMlBkRpzhF/su63A46dypo53s39Ti0CpgedQdAp/AY9Dz8WIocOGYi4mErzNQk6h48pa3NQmG1SlIPYxCu3b2+R34sRoKTfensSXQwnG2gw4j3PaGmQZHWm/o38usob5RtOBGtgOcdyXlm5wq/UMON/YBUxnPysI5ezsWqd8L/kSY7qtXTkn8HJDqQLwOYPfBlRAts9DZ499cfLvG718g4tca8Iv2prfYXLgTvIn/91xI9nOSeRhaCpBS6L4d3Kz52v/XCDMZBfiLz8Sqd4nGghWCnjm2cy5SmKCncesht181pbMgnaoGzj7kXvxhser/RYjmFFarKr/LOujh1h7ztpEQHC5cA2WHEe+adoO3/nWElgFtD5UUbgbW6IM3xWhCwyGrcl2+qbK//5Eh+It1ztGnLUb1b3q7TAmEofeEahsa/5/1d2bKyjyWOTexQRtqqfQAKrk0amkVyjiBcoOasACjZ6Jqt2ckkVsa+qPpGxHZ3cXHu0enKOTQ+hpv1JQXxdiRPJ5LG4Syy0iYez1pXNa230fbCYN+hyYEGzQD8Q6DbNz9mmzyTYPi2hVx1Bvyy4bzIu6gkbISp44KqQ4m+q1VvcyC6+YoNpIvELJV2zA2WzivmnY6cZbBaFbecn6vB2CX7D/tz02CqRQxdpZ26KRaSYLqFzmKCvPz6OSfzXaFZrFm6TkC1Su+wSSA0TCYlw0/NBW0J1VqMk0IN9NKbnmGEJ2VYZCzAUYD7glxq9mg7tEIqD5Gsfp1GKNrOqtDMZt6p+GZkVf84fQAvaM0eZxMTFvIni6M6ZX/JBr5/VplOAm1+rxt1LJOS/pruJ/v08wUVLlFsF2P1+wt3B3bRewb8HZRGAyjIYgdG7HMMxtCdeWAPfB9MYbN2X7dbEg3G4wQ0KVq4btAt/o6ZCyLiyLHNcBq9KiCM8xV+4Ilqqbz+YR3Ro5dAW38vpfJEutv7G5YrMUCCAOuoFI5vhDyssPb1AdH0B69UUZZU7KYGz2muyLhSUWepuUbGm/aboz0IRlQ8vaOvzkhJINFstr1PpfYIOoo5Zwxkry5SThT2ou9zwqvb5bmLo5v6qn521bpIHVYekyVe0dDYeu0PX6xB4BGJ+Z3T8T6xgXshm617NHVjk+X8sR4TdVcp6wujR9kXJKpTLNCLCst6xzczgfEVEXZS+Ey6t7xVCgEYvzXuNmdjeCSms+GyyKwVZyLNog1z4VcSXnXwj6naxm+Uv6fXY8GDwjWAfuUm/RwfTWZf0qTmi5+5jCyyWM8gV/TbTqnKrzK41rEEzyePSGba5WL/LZvqYZB8hgSaMTPvVoLtT8tD9zD9N6/bvnh03wHC/rI9gbVmwtrgDX87AulUfoPqjLe+rJ7170Dz9cgAIghnJkGpBUNnYggctVJKzPGWjzB1L/8g4j24Zn7nMt0EUBlqIPLF2NtRm0DtuLfqWUaerx+4+0ihsUsIeE3Xw5sllJCKx7WEFdidfhuKKBhKQRDg348hKByEzCWOfI7+M2C+Oy7BXLaWxR5pzFtqmnj0PsfWRTPoLQdo20XVGhD0iOlUvoCdKdGD7W71Y+Xy4WvrLg1lHuEp7oD8icp3zid7BItasakYIPV5kaymPZXIz0akKef/bfLcsChNmqI6CAsqC3kXjQG0RoU/ubDOtMcO6E+eajN6+G80E+YiLu1dXst+N7pPlWyM4Lvf2q6V1xf5AGeOw133+czAuYxUdVA8bUSUk72ZoPtrPQkkfe8DpSaI7qK2y5qRojqMzM9SZW9VKfizV3yLlGPLWkWdy+fI+r7gjmEYgcBoDv3fkG9QeZ/vWI8Hs4C4BNbMTqfmWtMIpum7QQjQioLHh53ZxYZbweSZf3ZvCr5ovk42ORpGEriftcnLJM/cHp/hd+ZMUrd+pGYPDEtgP3D/tJIIdR9CSlDFLiQHz9kss/2cCqUHDJvkBIeFfBhAWWQejJpoqqvSY38zt8Q8md/BPS2eq3O4hRNGo8wKaqxOwvDo7xvGXXFKgQlNfrTSaR0LNhUspH18rE6OO343JLsNjyhsr2ZLP0/SM1Mx27RHlcoViJw302Rgr5/31jVEw+IBUSFypnl2PfrSRxt7rjkz9c26V3Jc1SB235V7+hZQ7D2WU30h8EAhTJ+RG8bKfrE8PCyH8Ac4/K1rVHcKudiqP9D8C/y72mFArJDuQ7WHqvzjM7FppBt5wo3d2qnIP5tZl+MLp7UCwG+w4vj5NF3Azu0v7KrlAUXa1YU/TWCQoAZdN5dCETVVE627oRdMcAkTB+sDyIf9Ox+T3zE4CptSszk3wC3L25ZjYnrlv9AWnsD13VyTnGB+aCiqvOdawdzeuphoPJ/Ao6jI8rXQAfuCnEGSfb7tu5r8lx16PkHHPjQpJH+ndA0o/dpFuEOyPkYjHv+racugVScCcLGoJs4f0ej0QqzTIRhS91LZocV0Sn7wcfRWUy0PwcamYZRko9TuzCiAMOquNTPUUEloo6o9wjw/v1phFXWoU/GaaAdzGSG+5cECuGlmjrJLhgTX0ZA4BeJGfjAsi+JQouyZG2X9Whcw9ZWpQoWSAhZGQhJyKzSgiPzKJD2lr8lNeL8NJSe+TJj23xiiWG8fM/6FnX9XH451raemqAQSRMIJCGIkIsLvR3FieN/A9A2c1e85MLuT+WJpaiq55Tffx7Av5e69utk0+RIijlyXRawDviJMVtMoSidYQGTO2H61zK71fjVy2TO07e/o3w8seqVDGl27ihzvXDKRZaAcSYilVA+v+SLhqmQrDeL9lXLrau+gs9wEAK8eNzg/oZKj0UQ+ZjAQT7CgnD7vz6/uF3BDGgqiruTh9Nd3b28P5mE6vhL5L4LegMQKdIzNIpY0xgyzTAQCERzzIVcpnrk5g2+gJhYE5nm6IPRUIlmTOucvjmd8GkW8acd9c8aKYr04+G4WYGD5wtQC5xjN8C0N3vC/hWzju9KmTgA3Tv9h53TzrKkwEUO6p/C2bzx25jOBjJJznDz7+r7kNWrfLW3TG7t6CNy7G5+cqfaJiJWZq6QgLNVLrOjroSKY3P/wjSzzfn3t3S8Ox5dYNqd6L45Q2E3KOaEBsTJy9LAYpciJ/OmrLwb+3/jz3F4ZHk7EVb27YQraJNH3GkcHlQ9F4EH/ybbUtHK0Mmfhef1PtL+IZWJFk8nd11C4ojPW0kDddjs6Fpxu7rPjIzKL0fsadPCrqxlXPLsY45eGGPRuG0ttRWVL57BCAO8NGxbmStDrvCVy3Nm831+jzL6ZThgv/iD9Sf+r5e4pJ81QIB3iHk+pqZSOGOXcC74f3WApfnNfkZpcnqKXHwY/lxZK89pNmzbJoKT+yC1ulBNsg6HLMKGVdfwyfxKi1rOcJZqxADqelRU3K/mGdS9dV8iQRGYwKpESFU8NlkIR1FrctZbZx0WzpxsJlazHIQdXAarfjaNuv4z7DAGS7oJg6p4oZu9Jp4lfNpGWv7moes3YZZ0TbXdoLXMq+Xqa+8aO1GlMdpolps2t5T1VyST6s8zcpYBUM4AmbLE1a2Po9fJpXBrnCnOzin9XYwQV+1pJ/e3rK1o1IIOsE52zW2wLckpw82Bqlf9EOKfA7xtv4CE="
              />
            </div>

            <div class="aspNetHidden">
              <input
                type="hidden"
                name="__VIEWSTATEGENERATOR"
                id="__VIEWSTATEGENERATOR"
                value="CBB2B409"
              />
              <input
                type="hidden"
                name="__EVENTVALIDATION"
                id="__EVENTVALIDATION"
                value="zN/eqcTVOvpGuVPy7RGUqEIr1khC+yQ73hTtFpnqU8i4oCPE2BNkOo/ADE3CnY4ROZCqs+lVeEFEP1KgrjEiDuuAPgZpY2P2VphzcJ2SHXsRRsHxS0vE0tcDCmmXTbSJLoL9GZUVeaD8LtEhWlJxZ68tM5K2GDYu/MtynRElovEdx5B+p6dp87WPI12GZkOSOFoFDzbSxQEzhRklCvVdkb06Ggi/wJ0lyFDJ7/F11FRC17WL4U1xNy8nHfLkkZ87byGL95ao9ZiwRyaJvcHCDdv5aqt16h8wCBY0qqC3oiI207fGXoBd2MmrsPvediYAvI7ApZrUsk8clcCF0FBq3aFYiStpjlTrEHD07gRfXqgaZvg+4r5AuTXrbH8e6T0WbL0Rx1D0Qe+HZCMsuz8eUtu3ZGFsJ4AtCyX9R5NAnEesBhBGC232XJ8Rx422n46iUdkfXlOcq3WFvcM4yUkP6mPW4K1qtodoWsk+JL6X05XWRfsMzE51Un0wQYeBWbMF50rjZC6Whn6/THxayyCa/x0aBE+yqkVAoOmPqVfrm32K+rg4jhB/XdZbptBFT69CYmgSK4E27wEB3q6Z5oCqWbpBMz1GKpgsTiq7Fz3EV7A="
              />
            </div>
            <div class="text-center mb-3">
              <div class="w-md-75 w-lg-75 mx-md-auto">
                <h1 class="h3">Verify &amp; Publish Contract Source Code</h1>
                <small class="d-block text-muted color-strong"
                  >COMPILER TYPE AND VERSION SELECTION</small
                >
              </div>
            </div>
            <hr />
            <div class="pt-2 pb-4">
              <div class="row">
                <div class="col-md-10 offset-md-1 text-secondary mt-3 mb-2">
                  <img
                    src="../assets/images/svg/icons/undraw.svg"
                    width="115"
                    align="left"
                    style="
                      margin-top: -15px;
                      margin-bottom: 10px;
                      margin-right: 10px;
                    "
                  />
                  Source code verification provides <b>transparency</b> for
                  users interacting with smart contracts. By uploading the
                  source code, Etherscan will match the compiled code with that
                  on the blockchain. Just like contracts, a "smart contract"
                  should provide end users with more information on what they
                  are "digitally signing" for and give users an opportunity to
                  audit the code to independently verify that it actually does
                  what it is supposed to do.
                </div>
              </div>
              <div class="w-md-75 w-lg-50 mx-md-auto mt-2">
                <div class="js-form-message form-group">
                  <label class="d-block" for="txtUserName"
                    >Please enter the Contract Address you would like to
                    verify</label
                  >
                  <input
                    name="ctl00$ContentPlaceHolder1$txtContractAddress"
                    v-model="address"
                    maxlength="42"
                    id="ContentPlaceHolder1_txtContractAddress"
                    class="form-control form-control-sm"
                    required=""
                    placeholder="0x..."
                    data-success-class="u-has-success"
                    data-error-class="u-has-error"
                    data-rule-minlength="40"
                    type="search"
                    data-msg-minlength="Invalid Length"
                    data-msg="Required"
                    data-name="txtContractAddress"
                    data-rule-maxlength="42"
                  />
                </div>
                <div class="js-form-message form-group">
                  <label class="d-block mt-4"
                    >Please select Compiler Type</label
                  >
                  <select
                    name="ctl00$ContentPlaceHolder1$ddlCompilerType"
                    onchange="javascript:;"
                    id="ContentPlaceHolder1_ddlCompilerType"
                    class="custom-select custom-select-sm mb-1"
                    required=""
                    v-model="compile_type"
                  >
                    <option selected="selected" value="">
                      [Please Select]
                    </option>
                    <option
                      value="1"
                      title="A simple interface for solidity code that fits or concatenated into a single file"
                    >
                      Solidity (Single file)
                    </option>
                    <option
                      value="2"
                      title="Support for multi-part/file solidity code with imports"
                    >
                      Solidity (Multi-Part files)
                    </option>
                  </select>
                  <div id="tooltip_container"></div>
                </div>

                <span id="ContentPlaceHolder1_compilerversion">
                  <div class="js-form-message form-group u-has-success">
                    <label class="d-block mt-4"
                      >Please select Compiler Version</label
                    >
                    <select
                      name="ctl00$ContentPlaceHolder1$ddlCompilerVersions"
                      id="ContentPlaceHolder1_ddlCompilerVersions"
                      class="custom-select custom-select-sm"
                      required=""
                      data-msg="Required"
                      data-error-class="u-has-error"
                      data-success-class="u-has-success"
                      aria-invalid="false"
                      v-model="selectedVersion"
                    >
                      <option value="">[Please Select]</option>
                      <option value="v0.8.12+commit.f00d7308">
                        v0.8.12+commit.f00d7308
                      </option>
                      <option value="v0.8.11+commit.d7f03943">
                        v0.8.11+commit.d7f03943
                      </option>
                      <option value="v0.8.10+commit.fc410830">
                        v0.8.10+commit.fc410830
                      </option>
                      <option value="v0.8.9+commit.e5eed63a">
                        v0.8.9+commit.e5eed63a
                      </option>
                      <option value="v0.8.8+commit.dddeac2f">
                        v0.8.8+commit.dddeac2f
                      </option>
                      <option value="v0.8.7+commit.e28d00a7">
                        v0.8.7+commit.e28d00a7
                      </option>
                      <option value="v0.8.6+commit.11564f7e">
                        v0.8.6+commit.11564f7e
                      </option>
                      <option value="v0.8.5+commit.a4f2e591">
                        v0.8.5+commit.a4f2e591
                      </option>
                      <option value="v0.8.4+commit.c7e474f2">
                        v0.8.4+commit.c7e474f2
                      </option>
                      <option value="v0.8.3+commit.8d00100c">
                        v0.8.3+commit.8d00100c
                      </option>
                      <option value="v0.8.2+commit.661d1103">
                        v0.8.2+commit.661d1103
                      </option>
                      <option value="v0.8.1+commit.df193b15">
                        v0.8.1+commit.df193b15
                      </option>
                      <option value="v0.8.0+commit.c7dfd78e">
                        v0.8.0+commit.c7dfd78e
                      </option>
                      <option value="v0.7.6+commit.7338295f">
                        v0.7.6+commit.7338295f
                      </option>
                      <option value="v0.7.5+commit.eb77ed08">
                        v0.7.5+commit.eb77ed08
                      </option>
                      <option value="v0.7.4+commit.3f05b770">
                        v0.7.4+commit.3f05b770
                      </option>
                      <option value="v0.7.3+commit.9bfce1f6">
                        v0.7.3+commit.9bfce1f6
                      </option>
                      <option value="v0.7.2+commit.51b20bc0">
                        v0.7.2+commit.51b20bc0
                      </option>
                      <option value="v0.7.1+commit.f4a555be">
                        v0.7.1+commit.f4a555be
                      </option>
                      <option value="v0.7.0+commit.9e61f92b">
                        v0.7.0+commit.9e61f92b
                      </option>
                      <option value="v0.6.12+commit.27d51765">
                        v0.6.12+commit.27d51765
                      </option>
                      <option value="v0.6.11+commit.5ef660b1">
                        v0.6.11+commit.5ef660b1
                      </option>
                      <option value="v0.6.10+commit.00c0fcaf">
                        v0.6.10+commit.00c0fcaf
                      </option>
                      <option value="v0.6.9+commit.3e3065ac">
                        v0.6.9+commit.3e3065ac
                      </option>
                      <option value="v0.6.8+commit.0bbfe453">
                        v0.6.8+commit.0bbfe453
                      </option>
                      <option value="v0.6.7+commit.b8d736ae">
                        v0.6.7+commit.b8d736ae
                      </option>
                      <option value="v0.6.6+commit.6c089d02">
                        v0.6.6+commit.6c089d02
                      </option>
                      <option value="v0.6.5+commit.f956cc89">
                        v0.6.5+commit.f956cc89
                      </option>
                      <option value="v0.6.4+commit.1dca32f3">
                        v0.6.4+commit.1dca32f3
                      </option>
                      <option value="v0.6.3+commit.8dda9521">
                        v0.6.3+commit.8dda9521
                      </option>
                      <option value="v0.6.2+commit.bacdbe57">
                        v0.6.2+commit.bacdbe57
                      </option>
                      <option value="v0.6.1+commit.e6f7d5a4">
                        v0.6.1+commit.e6f7d5a4
                      </option>
                      <option value="v0.6.0+commit.26b70077">
                        v0.6.0+commit.26b70077
                      </option>
                      <option value="v0.5.17+commit.d19bba13">
                        v0.5.17+commit.d19bba13
                      </option>
                      <option value="v0.5.16+commit.9c3226ce">
                        v0.5.16+commit.9c3226ce
                      </option>
                      <option value="v0.5.15+commit.6a57276f">
                        v0.5.15+commit.6a57276f
                      </option>
                      <option value="v0.5.14+commit.01f1aaa4">
                        v0.5.14+commit.01f1aaa4
                      </option>
                      <option value="v0.5.13+commit.5b0b510c">
                        v0.5.13+commit.5b0b510c
                      </option>
                      <option value="v0.5.12+commit.7709ece9">
                        v0.5.12+commit.7709ece9
                      </option>
                      <option value="v0.5.11+commit.22be8592">
                        v0.5.11+commit.22be8592
                      </option>
                      <option value="v0.5.11+commit.c082d0b4">
                        v0.5.11+commit.c082d0b4
                      </option>
                      <option value="v0.5.10+commit.5a6ea5b1">
                        v0.5.10+commit.5a6ea5b1
                      </option>
                      <option value="v0.5.9+commit.c68bc34e">
                        v0.5.9+commit.c68bc34e
                      </option>
                      <option value="v0.5.9+commit.e560f70d">
                        v0.5.9+commit.e560f70d
                      </option>
                      <option value="v0.5.8+commit.23d335f2">
                        v0.5.8+commit.23d335f2
                      </option>
                      <option value="v0.5.7+commit.6da8b019">
                        v0.5.7+commit.6da8b019
                      </option>
                      <option value="v0.5.6+commit.b259423e">
                        v0.5.6+commit.b259423e
                      </option>
                      <option value="v0.5.5+commit.47a71e8f">
                        v0.5.5+commit.47a71e8f
                      </option>
                      <option value="v0.5.4+commit.9549d8ff">
                        v0.5.4+commit.9549d8ff
                      </option>
                      <option value="v0.5.3+commit.10d17f24">
                        v0.5.3+commit.10d17f24
                      </option>
                      <option value="v0.5.2+commit.1df8f40c">
                        v0.5.2+commit.1df8f40c
                      </option>
                      <option value="v0.5.1+commit.c8a2cb62">
                        v0.5.1+commit.c8a2cb62
                      </option>
                      <option value="v0.5.0+commit.1d4f565a">
                        v0.5.0+commit.1d4f565a
                      </option>
                      <option value="v0.4.26+commit.4563c3fc">
                        v0.4.26+commit.4563c3fc
                      </option>
                      <option value="v0.4.25+commit.59dbf8f1">
                        v0.4.25+commit.59dbf8f1
                      </option>
                      <option value="v0.4.24+commit.e67f0147">
                        v0.4.24+commit.e67f0147
                      </option>
                      <option value="v0.4.23+commit.124ca40d">
                        v0.4.23+commit.124ca40d
                      </option>
                      <option value="v0.4.22+commit.4cb486ee">
                        v0.4.22+commit.4cb486ee
                      </option>
                      <option value="v0.4.21+commit.dfe3193c">
                        v0.4.21+commit.dfe3193c
                      </option>
                      <option value="v0.4.20+commit.3155dd80">
                        v0.4.20+commit.3155dd80
                      </option>
                      <option value="v0.4.19+commit.c4cbbb05">
                        v0.4.19+commit.c4cbbb05
                      </option>
                      <option value="v0.4.18+commit.9cf6e910">
                        v0.4.18+commit.9cf6e910
                      </option>
                      <option value="v0.4.17+commit.bdeb9e52">
                        v0.4.17+commit.bdeb9e52
                      </option>
                      <option value="v0.4.16+commit.d7661dd9">
                        v0.4.16+commit.d7661dd9
                      </option>
                      <option value="v0.4.15+commit.8b45bddb">
                        v0.4.15+commit.8b45bddb
                      </option>
                      <option value="v0.4.15+commit.bbb8e64f">
                        v0.4.15+commit.bbb8e64f
                      </option>
                      <option value="v0.4.14+commit.c2215d46">
                        v0.4.14+commit.c2215d46
                      </option>
                      <option value="v0.4.13+commit.0fb4cb1a">
                        v0.4.13+commit.0fb4cb1a
                      </option>
                      <option value="v0.4.12+commit.194ff033">
                        v0.4.12+commit.194ff033
                      </option>
                      <option value="v0.4.11+commit.68ef5810">
                        v0.4.11+commit.68ef5810
                      </option>
                    </select>
                  </div>
                  <div
                    id="ContentPlaceHolder1_divMajorBuildsOnly"
                    class="custom-checkbox d-flex align-items-center text-muted"
                    style="margin-top: -8px"
                  ></div>
                </span>
                <span id="ContentPlaceHolder1_licenseType">
                  <div
                    class="js-form-message form-group"
                    style="display: block"
                  >
                    <label class="d-block mt-4"
                      >Please select Open Source License Type
                      <a
                        href="/contract-license-types"
                        target="_blank"
                        data-toggle="tooltip"
                        title=""
                        data-original-title="Contract Source Code License Type, click for more info"
                        ><i class="far fa-info-circle"></i></a
                    ></label>
                    <select
                      name="ctl00$ContentPlaceHolder1$ddlLicenseType"
                      id="ContentPlaceHolder1_ddlLicenseType"
                      title="Select a suitable license type"
                      class="custom-select custom-select-sm"
                      required=""
                      data-msg="Required"
                      data-error-class="u-has-error"
                      data-success-class="u-has-success"
                      v-model="license_type"
                    >
                      <option value="">[Please Select]</option>
                      <option value="1">1) No License (None)</option>
                      <option value="2">2) The Unlicense (Unlicense)</option>
                      <option value="3">3) MIT License (MIT)</option>
                      <option value="4">
                        4) GNU General Public License v2.0 (GNU GPLv2)
                      </option>
                      <option value="5">
                        5) GNU General Public License v3.0 (GNU GPLv3)
                      </option>
                      <option value="6">
                        6) GNU Lesser General Public License v2.1 (GNU LGPLv2.1)
                      </option>
                      <option value="7">
                        7) GNU Lesser General Public License v3.0 (GNU LGPLv3)
                      </option>
                      <option value="8">
                        8) BSD 2-clause "Simplified" license (BSD-2-Clause)
                      </option>
                      <option value="9">
                        9) BSD 3-clause "New" Or "Revised" license
                        (BSD-3-Clause)
                      </option>
                      <option value="10">
                        10) Mozilla Public License 2.0 (MPL-2.0)
                      </option>
                      <option value="11">
                        11) Open Software License 3.0 (OSL-3.0)
                      </option>
                      <option value="12">12) Apache 2.0 (Apache-2.0)</option>
                      <option value="13">
                        13) GNU Affero General Public License (GNU AGPLv3)
                      </option>
                      <option value="14">
                        14) Business Source License (BSL 1.1)
                      </option>
                    </select>
                  </div>
                </span>
                <p align="center" class="mt-3">
                  <span
                    class="
                      custom-control custom-checkbox
                      align-items-center
                      text-muted
                      mb-2
                    "
                  >
                    <input
                      name="chkTermsOfUse"
                      type="checkbox"
                      id="chkTermsOfUse"
                      class="custom-control-input align-items-center"
                      :checked="checked"
                     
                    />
                    <label
                      class="custom-control-label"
                      for="ContentPlaceHolder1_chkRemember"
                    >
                      <span>I agree to the terms of service</span>
                    </label>
                  </span>
                  <input
                    type="button"
                    name="ctl00$ContentPlaceHolder1$btnSubmit"
                    value="Continue"
                    @click="toSure"
                    id="ContentPlaceHolder1_btnSubmit"
                    class="btn btn-primary mr-2"
                  />
                  <input
                    type="button"
                    name="ctl00$ContentPlaceHolder1$btnReset"
                    value="Reset"
                    @click="resetSelect"
                    id="ContentPlaceHolder1_btnReset"
                    formnovalidate="formnovalidate"
                    class="btn btn-soft-secondary"
                  />
                </p>
              </div>
              <input
                type="hidden"
                name="ctl00$ContentPlaceHolder1$libcounter"
                id="ContentPlaceHolder1_libcounter"
                value="1"
              />
            </div>
          </form>
        </div>
      </main>
    </div>
    <comfooter></comfooter>
  </div>
</template>
<script>
import comheader from "@/components/serach_header";
import comfooter from "@/components/comfooter";
export default {
  data() {
    return {
      checked: true,
      address: "",
      selectedVersion: "",
      compile_type: "",
      license_type: "",
    };
  },
  components: {
    comheader,
    comfooter,
  },
  async mounted() {
    let that = this;

    if (JSON.stringify(that.$route.params) != "{}") {
      that.address = that.$route.params.address;
      sessionStorage.setItem("contract_addr", that.address);
    } else {
      that.address = sessionStorage.getItem("contract_addr");
    }
  },
  methods: {
    ifChecked(){

      let that = this;
      if(!that.checked){
        that.checked = true
      }else{
        that.checked = false
      }
    },
    resetSelect() {
      let that = this;
      that.compile_type = "";
      that.selectedVersion = "";
      that.license_type = "";
    },
    toSure() {
      let that = this;
      if (
        that.address == "" ||
        that.compile_type == "" ||
        that.selectedVersion == "" ||
        that.license_type == ""
      )
        return;
      that.$router.push({
        name: "sourcesure",
        params: {
          address: that.address,
          selectedVersion: that.selectedVersion,
        },
      });
    },
  },
  watch: {
    selectedVersion() {},
  },
};
</script>
